import { ArrowIcon, DoubleHalfCircleIcon } from '@nwwp/ui-shadcn'
import type { FunnelStepTerminalComponent } from '../../types'
import { FunnelStep } from '../FunnelStep'
import { MatchHandoff } from '../MatchHandoff'

export const RedirectToMatch: FunnelStepTerminalComponent = () => (
  <FunnelStep.Terminal data-testid="redirect-to-match">
    <div className="flex flex-col gap-4">
      <h1 className="text-title-xl text-white">
        We are not the right fit for you right now{' '}
        <DoubleHalfCircleIcon className="inline-block translate-y-2 scale-75" />
      </h1>
      <div className="flex items-center gap-4">
        <ArrowIcon />
        <h1 className="text-title-xl text-white">But don&rsquo;t worry...</h1>
      </div>
    </div>
    <MatchHandoff />
  </FunnelStep.Terminal>
)

RedirectToMatch.path = 'redirect-to-match'
